import { PencilRuler, UserRound } from "lucide-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import schema from "./schema";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { useUpdateProfileMutation } from "@/redux/features/api/profile/profileApiSlice";
import UserInput from "./UserInput";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { useCreatePaidConsultationMutation } from "@/redux/features/api/Consultation/consultationApiSlice";
import { useTranslate } from "@/components/base/providers/TranslateProv";
import { toast } from "react-toastify";

type Props = {
  data: any;
  selectedTimeId: any;
  selectedDateId: any;
};

function PaidConsultationForm({ data, selectedTimeId, selectedDateId }: Props) {
  const [selectedMethod, setSelectedMethod] = useState("0");
  const [phone, setPhone] = useState<string>("");
  const [whatsappNumber, setWhatsappNumber] = useState<string>("");
  const [message, setMessage] = useState<string>("");

  const [updateProfile] = useUpdateProfileMutation();
  const [
    createPaidConsultation,
    { data: paid, error, isSuccess, isLoading: loading },
  ] = useCreatePaidConsultationMutation();

  const prepareDefaultValues = (data: any) => {
    if (!data) return {};

    return {
      percentage: data.percentage || "",
      communicate_at: data.communicate_at || "",
      year_obtained: data.year_obtained || "",
      country_obtained: data.country_obtained || "",
      year_obtaining_certificate: data.year_obtaining_certificate || "0",
      country_obtaining_certificate: data.country_obtaining_certificate || "0",
    };
  };

  const form = useForm<Yup.InferType<typeof schema>>({
    resolver: yupResolver(schema),
    defaultValues: prepareDefaultValues(data),
  });

  const {
    getValues,
    handleSubmit,
    control,
    reset,
    formState: { errors },
  } = form;

  useEffect(() => {
    if (data) {
      reset(prepareDefaultValues(data));
      setPhone(data?.phone_number || "");
      setWhatsappNumber(data?.whatsapp || "");
      setSelectedMethod(`${data?.communicate_at || "0"}`);
    }
  }, [data, reset]);

  const onSubmit = async (data: Yup.InferType<typeof schema>) => {
    const communicate =
      selectedMethod === "0"
        ? "whatsapp"
        : selectedMethod === "1"
        ? "email"
        : "phone";
    const sendValues = {
      communicate,
      message,
      consultation_time_id: selectedDateId,
      consultation_hour_id: selectedTimeId,
    };

    const updateUserData = {
      communicate_at: selectedMethod,
      phone_number: phone,
      whatsapp: whatsappNumber,
      percentage: data.percentage || "0",
      year_obtaining_certificate: data.year_obtaining_certificate || "0",
      country_obtaining_certificate: data.country_obtaining_certificate || "0",
    };

    try {
      await updateProfile(updateUserData).unwrap();
      await createPaidConsultation(sendValues).unwrap();
    } catch (error) {
      toast.error("حدث خطأ ما");
    }
  };

  const { locale } = useTranslate();
  useEffect(() => {
    if (isSuccess) {
      // const win = window.open("");
      // if (win) {
      //   win.location.href = paid.data.url;
      //   window.location.reload();
      // } else {
      //   toast.error("حدث مشكله، يرجي المحاوله مره اخري");
      // }
      window?.location.assign(paid.data.url);
    }
  }, [isSuccess]);
  return (
    <div className="bg-white shadow-sm border lg:p-[30px] rounded-[16px]">
      <div className="flex items-center flex-col justify-center">
        <div className="w-full">
          <form onSubmit={handleSubmit(onSubmit)} className="p-2">
            <UserInput
              control={control}
              errors={errors}
              selectedMethod={selectedMethod}
              setSelectedMethod={setSelectedMethod}
              whatsappNumber={whatsappNumber}
              setWhatsappNumber={setWhatsappNumber}
              phone={phone}
              setPhone={setPhone}
              message={message}
              setMessage={setMessage}
            />
            <div className="mt-4 flex justify-between items-center p-4">
              <div className="w-full">
                <Button disabled={loading} className="grow text-lg w-full">
                  {locale === "ar"
                    ? "استشاره سفير الجامعات"
                    : "University Ambassador Consultation"}
                </Button>
              </div>
              <div className="w-fit relative">
                <Button className="w-fit bg-[#F8F9FA] mr-2 font-semibold text-primaryColor">
                  {locale === "ar" ? "399 جنية" : "399 EGP"}
                </Button>
                <Badge className="absolute -top-4 -left-[8px] bg-destructive rounded-full">
                  30%
                </Badge>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
}

export default PaidConsultationForm;
